module.exports = {
  PREVIEW_PATH: '/preview/:build_identifier'
}